/**
 * 设备指纹上报（防滥用，M2.5）。
 *
 * 用 FingerprintJS 开源版（@fingerprintjs/fingerprintjs）生成 visitorId，
 * 懒加载（动态 import，避免首屏体积），缓存 visitorId。
 *
 * 上报时机：进入工作台时调一次（WorkbenchLayout 挂载）。
 * 上报失败静默——指纹是 best-effort 防滥用信号，不影响用户主流程。
 */

import { apiFetch } from "./api";

let cachedVisitorId: string | null = null;

/**
 * 获取设备指纹 visitorId（懒加载 FingerprintJS，缓存结果）。
 * 加载失败返回空串（上报会被后端拒绝，但不抛错）。
 */
export async function getVisitorId(): Promise<string> {
  if (cachedVisitorId !== null) return cachedVisitorId;
  try {
    const FingerprintJS = await import("@fingerprintjs/fingerprintjs");
    const agent = await FingerprintJS.load();
    const result = await agent.get();
    cachedVisitorId = result.visitorId;
    return cachedVisitorId;
  } catch {
    cachedVisitorId = "";
    return "";
  }
}

/**
 * 上报设备指纹到后端（fire-and-forget，失败静默）。
 *
 * @param context 上报场景："signup" | "generate"
 */
export async function reportFingerprint(
  context: "signup" | "generate" = "signup",
): Promise<void> {
  try {
    const fingerprint = await getVisitorId();
    if (!fingerprint) return;
    await apiFetch("/api/abuse/fingerprint", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fingerprint, context }),
    });
  } catch {
    // 静默：防滥用上报失败不影响用户操作
  }
}
